import AbstractBlock from './abstractBlock.js';
import LeafetMap from 'ui/map/leafet-map';
import L from "leaflet";

const CONSTANT = {
    CLASS_HOLDER: 'js-enter_info_map__holder',
    CLASS_ADDRESS: 'js-enter_info_map__address',
    CLASS_CONFIRM: 'js-enter_info_map__confirm',
    CLASS_CANCEL: 'js-enter_info_map__cancel',
};

export default class MapBlock extends AbstractBlock {
    /**
     * Инициализируем поведение
     *
     * @param {jquery} element
     */
    init(element) {
        this.element = element.find('.js-enter_info_map');
        if (this.hasElement) {
            console.log('Map Block inited');
        } else {
            console.warn('Map Block no element');
            return;
        }

        this.holder = this.element.find(`.${CONSTANT.CLASS_HOLDER}`);
        this.$address = this.element.find(`.${CONSTANT.CLASS_ADDRESS}`);
        this.loaded = false;
        this.loading = false;
        this.point = null;
        this.request = null;
        this.suggest = null;

        this.element.on('click', `.${CONSTANT.CLASS_CONFIRM}`, ::this.confirm);
        this.element.on('click', `.${CONSTANT.CLASS_CANCEL}`, ::this.cancel);
    }

    /**
     * Произвести загрузку карты
     * @return {Promise} Обещание выполнить что-то после загрузки карты
     */
    load() {
        return new Promise((resolve, reject) => {
            if (this.loaded) {
                resolve();
                return;
            }
            const minZoom = window.BaseApp.initData.mapConfig.minZoom || null;
            const maxZoom = window.BaseApp.initData.mapConfig.maxZoom || null;
            const center = window.BaseApp.initData.center || null;

            let bounds = window.BaseApp.initData.mapConfig.bounds || null;

            if (bounds){
                bounds = L.latLngBounds(
                    [bounds.leftTop.y, bounds.leftTop.x],
                    [bounds.rightBottom.y, bounds.rightBottom.x]
                );
            }

            this.map = new LeafetMap(this.holder.get(0), {
                center: center || [55.75396, 37.620393],
                zoom: 17,
            });

            if (minZoom){
                this.map.map.setMinZoom(minZoom);
            }

            if (maxZoom){
                this.map.map.setMaxZoom(maxZoom);
            }

            if (bounds){
                this.map.map.setMaxBounds(bounds);
            }

            this.loaded = true;
            resolve();
        });
    }

    /**
     * Добавим точку по ее геоданным пришедшим из геокодера
     *
     * @param {Object} data
     *
     * @return {Promise} promise
     */
    addPointByData(data = {}) {
        return new Promise((resolve, reject) => {
            this.load().then(() => {
                if (!this.loaded) {
                    reject('Карта еще не загружена');
                    return;
                }
                if (this.point) {
                    this.map.removeLayer(this.point);
                }

                this.house = data;
                this.point = this.map.add(JSON.parse(data.geoObject));
                this.title = data.house;

                resolve();
            });
        });
    }

    set title(value = '') {
        this.$address.html(value);
    }

    /**
     * Подтвердить введенные данные
     */
    confirm() {
        if (!this.house) {
            console.warn('Не найдена точка для сохранения');

            return;
        }

        this.events.trigger('confirm', {
            extra: this.house,
            request: this.request,
            suggest: this.suggest,
        });
    }

    /**
     * Отменить шаг
     */
    cancel() {
        this.events.trigger('cancel');
    }
}
